var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx"},[_c('div',{staticClass:"wx-title"},[_vm._v("扫码下载App")]),_c('div',{staticClass:"wx-msg"},[_vm._v("随时随地和 HR 沟通")]),_c('img',{attrs:{"src":"https://files.wondercv.com/pc/code/jobSearchDownload.png","alt":"扫码下载App 随时随地和 HR 沟通"}})])
}]

export { render, staticRenderFns }